import { useEffect, useState } from "react";
import api from "../components/api";
import "./WishList.css";
import ProductItem from "../components/ProductItem";
import Icons from "../components/Icons";
import Spinner from "../components/Spinner";

export default function Wishlist() {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [subCategoriesList, setSubCategoriesList] = useState([]);
  const [activeTag, setActiveTag] = useState("");
  const [offset, setOffset] = useState(0);
  const pageSize = 10;
  const [hasMore, setHasMore] = useState(true);

  const WishlistEmpty = () => (
    <div className="text-center mt-5">
      <div className="empty-icon_wrapper mb-3">
        <Icons.Wishlist width="50" height="50" />
      </div>
      <div className="fw-semibold fs-4 mb-2 wishlist-empty-text">
        Your wishlist is empty
      </div>
    </div>
  );

  const wishListRequest = async (params = {}, initPage = false) => {
    try {
      setLoading(true);
      const res = await api.get("/profile/wishlist", {
        params: {
          limit: pageSize,
          offset: initPage ? 0 : offset,
          ...params,
        },
      });
      setLoading(false);

      const wishlistItems = Array.isArray(res.data)
        ? res.data
        : res.data.results || [];

      if (res.status === 200) {
        setHasMore(wishlistItems.length === pageSize);
        setList(initPage ? wishlistItems : [...list, ...wishlistItems]);
        if (initPage) setOffset(pageSize);
        else setOffset((prevOffset) => prevOffset + pageSize);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const subCategoriesRequest = async () => {
    try {
      const res = await api.get("/sub-categories", {
        params: {
          category: 1,
        },
      });
      if (res.status === 200) {
        setSubCategoriesList([{ id: "", name: "All products" }, ...res.data]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const reviewRequest = async ({ productId = "", ...rest }) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const res = await api.patch(`/products/${productId}/review`, rest, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setLoading(false);
      if (res.status === 200) {
        wishListRequest({ sub_category: activeTag }, true);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleChangeSubCategory = (item) => {
    setActiveTag(item.id);
    wishListRequest({ sub_category: item.id }, true);
  };

  const handleRemoveItem = (e, item) => {
    e.stopPropagation();
    reviewRequest({
      productId: item.id,
      wishlist: false,
    });
  };

  useEffect(() => {
    wishListRequest({ sub_category: "" }, true);
    subCategoriesRequest();
    // eslint-disable-next-line   react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='w-100 pt-4'>
      {/* Adding new styling to heading so it is consistent with rest of the pages */}
      <h3 className="wishlist-heading">My Wishlist</h3>
      {loading && <Spinner />}
      <div className="d-flex flex-wrap justify-content-center mt-4 mb-3">
        {subCategoriesList.map((item) => (
          <div
            className={
              "categories-tag" +
              (activeTag === item.id ? " categories-tag_active" : "")
            }
            key={item.id}
            onClick={() => handleChangeSubCategory(item)}
          >
            {item.name}
          </div>
        ))}
      </div>

      {list.length === 0 ? (
        <WishlistEmpty />
      ) : (
        <div className="row row-cols-2 row-cols-sm-4 row-cols-lg-4 row-cols-xl-5 g-4 mt-3">
          {list.map((item) => (
            <div className="col" key={item.id}>
              <div className="position-relative">
                <Icons.Close
                  className="position-absolute top-0 end-0"
                  style={{ zIndex: 100, cursor: "pointer" }}
                  onClick={(e) => handleRemoveItem(e, item)}
                />
                <ProductItem item={item} showWishListIcon={false} />
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="text-center mt-3">
          <button
            className="btn btn-primary text-white m-auto px-4"
            onClick={() => wishListRequest({}, false)}
          >
            Load more
          </button>
        </div>
      )}
    </div>
  );
}
